"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CloseButton = exports.LoadingContainer = exports.NoResults = exports.TableCol = exports.BackArrow = exports.BackButton = exports.PageTitle = exports.ProductName = exports.ImageBlock = exports.CrossIcon = exports.ColumnControls = exports.ColumnHeaderContainer = exports.AddToCartContainer = exports.TDataValues = exports.TDataHeader = exports.TDataText = exports.TRow = exports.Table = exports.Container = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const Typography_1 = __importDefault(require("@/Components/UI/Typography"));
const svg_components_1 = require("@/assets/svg-components");
const IMAGE_SIZE = 170;
exports.Container = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  flex: 1;

  table,
  th,
  td {
    border: 1px solid ${props => props.theme.palette.DARK_GRAY_20};
  }

  th {
    :first-child {
      border-top: 1px solid transparent;
      border-left: 1px solid transparent;
    }
  }
`;
exports.Table = styled_components_1.default.table `
  border-collapse: collapse;
  width: 100%;
  margin-top: ${props => props.theme.spacing.l3}px;
`;
exports.TRow = styled_components_1.default.tr `
  height: ${props => props.theme.constants.blockWidth.s4}px;
`;
exports.TDataText = (0, styled_components_1.default)(Typography_1.default) `
  line-height: ${props => props.theme.typography.lineHeight.s3}px;
  ${props => props.header && `font-weight: ${props.theme.typography.weight.bold};`}
`;
exports.TDataHeader = styled_components_1.default.td `
  padding-left: ${props => props.theme.spacing.s3}px;
  background: ${props => props.theme.palette.LIGHT_GRAY_5};
`;
exports.TDataValues = styled_components_1.default.td `
  text-align: center;
`;
exports.AddToCartContainer = styled_components_1.default.div `
  display: flex;
  justify-content: center;
  padding: ${props => props.theme.spacing.s4}px 0;

  > div {
    margin: 0;
  }
`;
exports.ColumnHeaderContainer = styled_components_1.default.div `
  padding: ${props => props.theme.spacing.s3}px;
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.s3}px;
  align-items: center;
`;
exports.ColumnControls = styled_components_1.default.div `
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
exports.CrossIcon = (0, styled_components_1.default)(svg_components_1.CrossIcon) `
  width: ${props => props.theme.spacing.s4}px;
  height: ${props => props.theme.spacing.s4}px;
`;
exports.ImageBlock = styled_components_1.default.div `
  width: ${IMAGE_SIZE}px;
  height: ${IMAGE_SIZE}px;
`;
exports.ProductName = (0, styled_components_1.default)(Typography_1.default) `
  font-weight: ${props => props.theme.typography.weight.medium};
  color: ${props => props.theme.palette.LIGHT_BLACK};
`;
exports.PageTitle = (0, styled_components_1.default)(Typography_1.default) `
  margin: ${props => props.theme.spacing.m5}px 0 ${props => props.theme.spacing.m1}px 0;
`;
exports.BackButton = styled_components_1.default.button `
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.s2}px;
  background: transparent;
  border: none;
  cursor: pointer;
`;
exports.BackArrow = (0, styled_components_1.default)(svg_components_1.ArrowLeftBigIcon) `
  width: ${props => props.theme.spacing.s5}px;
  height: ${props => props.theme.spacing.s5}px;
`;
exports.TableCol = styled_components_1.default.col `
  width: ${props => props.width};
`;
exports.NoResults = (0, styled_components_1.default)(Typography_1.default) `
  margin-top: ${props => props.theme.spacing.s4}px;
`;
exports.LoadingContainer = styled_components_1.default.div `
  display: flex;
  flex-grow: 1;
  justify-content: center;
  align-items: center;
`;
exports.CloseButton = styled_components_1.default.button `
  background-color: transparent;
  border: 0;
`;
exports.default = {
    Container: exports.Container,
    CloseButton: exports.CloseButton
};
